import { render, staticRenderFns } from "./GameSetupDetail.vue?vue&type=template&id=368a7376"
import script from "./GameSetupDetail.vue?vue&type=script&lang=ts"
export * from "./GameSetupDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports